import React, {
    useCallback,
    useEffect,
    useState,
    useContext
} from 'react';
import _ from 'lodash';
import appConfig from 'app-config';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { ViewModelForm, ViewModelServiceContext, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useModal } from '@jutro/components';
import { FormModalPopover } from 'ml-components-platform-react';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import { UnderlyingPolicyComponent } from 'ml-capability-quoteandbind-common-react';
import { MLStickyContinueSectionComponent } from 'gw-capability-gateway-quoteandbind-common-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { MLPolicyChangeDataHolderService,MLNavigationStepsTrackingService } from 'ml-services-common-react';
import { MLEndorsementFlowUtil, MLCapitalizeStringFilter, MLEndorsementUtil } from 'ml-portals-util-js';
import { MLAlertGroupComponent } from 'ml-components-common-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { PolicyChange } from 'gw-capability-policychange-common-react';
import { EndorsementService } from 'gw-capability-policychange';
import MLPUPEditVehicleComponent from '../../components/MLPUPEditVehicleComponent/MLPUPEditVehicleComponent';

import addUnderlyingPolicyPopupMetadata from '../../../ml-capability-quoteandbind-common-react/pages/UnderlyingPolicies/AddEditUnderlyingPolicyPopup.metadata.json5';
import metadata from './PUPVehiclesPagePolChange.metadata.json5';

import styles from './PUPVehiclesPagePolChange.module.scss';
import messages from './PUPVehiclesPagePolChange.messages'
import { ScrollToError } from '@jutro/legacy/wizard-next';


const alertNames = {
    addedVehicleName: 'addedVehicle',
    replacedVehicleName: 'replacedVehicle'
};
function PUPVehiclesPagePolChange(props) {
    const modalApi = useModal();
    const {
        wizardData,
        updateWizardData,
        goNext,
        currentStepIndex,
        steps,
        currentStep,
        changeNextSteps,
    } = props;
    const { submissionVM, alertMessages } = wizardData;
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();

    const { authHeader } = useAuthentication();
    const { onValidate } = useValidation('PUPVehiclesPagePolChange');
    const { refreshData } = useDataRefresh();

    const isGPA = appConfig.portalCode === 'GPA';
    const isAMP = appConfig.portalCode === 'AMP';
    const pupModel = _.get(submissionVM, 'lobData.personalUmbrella');
    const vehiclesVM = _.get(submissionVM, 'lobData.personalUmbrella.coverables.vehicles');
    const underlyingPoliciesVM = _.get(submissionVM, 'lobData.personalUmbrella.underlyingPolicies');
    const productCode = _.get(submissionVM, 'baseData.productCode.value', '');
    const isPersonalUmbrella = submissionVM.value.isPersonalUmbrella();
    const isModernProduct = _.get(submissionVM, 'isModernProduct_Ext.value', false);
    const isUMB_NP = isPersonalUmbrella && isModernProduct;

    const [currentVehicleVM, setCurrentVehicleVM] = useState(viewModelService.create({}, 'pc', 'metlife.edge.capabilities.common.plugin.dto.PUPVehicleDTOML'));
    const [pageAction, setPageAction] = useState('');
    const [showValidationErrors, setShowValidationErrors] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [isloaded,setIsLoaded]= useState(false);
    const [replacedFixedId, setReplacedFixedId]= useState('');

    const {
        addSuccessAlert,
        addErrorAlert,
        clearBlockAlerts
    } = MLNotificationBlockUtil();

    const MLAlertService = MLNotificationBlockUtil();

    const {
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();

    const initPageAction = () => {
        switch (MLPolicyChangeDataHolderService.getPageAction()) {
            case 'add':
                setPageAction('add');
                MLNavigationStepsTrackingService.addToDynamicSteps(
                    translator(messages.addVehicleStep), !currentStep.existingStep, currentStep.mlStepName, authHeader);
                break;
            case 'replace':
                setPageAction('replace');
                MLNavigationStepsTrackingService.addToDynamicSteps(
                    translator(messages.replaceVehicleStep), !currentStep.existingStep, currentStep.mlStepName, authHeader);
                break;
            case 'edit':
                setPageAction('edit');
                MLNavigationStepsTrackingService.addToDynamicSteps(
                    translator(messages.editVehicleStep), !currentStep.existingStep, currentStep.mlStepName, authHeader);
                break;
            default:
                break;
        }
    };

    const initCurrentVehicleVM = () => {
        if (pupModel) {
            let index = vehiclesVM.value.findIndex((vhc) => vhc.isSelected === true);
            if (index === -1) {
                index = vehiclesVM.children.findIndex((vhc) => {
                    return vhc.value.vin === currentStep.fixedId;
                });
            }

            const selectedVehicleVM = vehiclesVM.getElement(index);
            selectedVehicleVM.value.toComplete_ML = true;
            if (MLPolicyChangeDataHolderService.getPageAction() === 'replace' && selectedVehicleVM.value.vehicleBeingReplaced) {
                const alertMessage = (
                    <FormattedMessage
                        {...messages.addReplacedVehicle}
                        values={{
                            strongName: <strong>{selectedVehicleVM.value.vehicleBeingReplaced}</strong>
                        }}
                    />
                );
                addSuccessAlert(alertMessage, alertNames.replacedVehicleName);
            }
            if (!selectedVehicleVM.value.error) {
                selectedVehicleVM.value.error = {
                    message: undefined
                };
            }
            setCurrentVehicleVM(selectedVehicleVM);
        }
    };

    const initVehiclePolChangePage = () => {
        if (currentStep.pageAction) {
            MLPolicyChangeDataHolderService.setPageAction(currentStep.pageAction);
        }

        const fixedId = currentStep.replacedFixedId || MLPolicyChangeDataHolderService.getReplacedFixedId();
        if (MLPolicyChangeDataHolderService.getPageAction() === 'replace' && !!fixedId) {
            setReplacedFixedId(fixedId);
            MLPolicyChangeDataHolderService.setReplacedFixedId('');
        }

        initCurrentVehicleVM();
        initPageAction();
    };

    useEffect(() => {
        if (!_.isEmpty(currentVehicleVM.value)) {
            setIsLoaded(true);
        }
    },[currentVehicleVM]);

    useEffect(() => {
        if (MLEndorsementFlowUtil.startingPointPageLoadIsSkipping(submissionVM, goNext, steps, currentStepIndex, changeNextSteps)) {
            return;
        }
        initVehiclePolChangePage();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getPageHeader = () => {
        switch (pageAction) {
            case 'add':
                return translator(messages.addVehicle); 
            case 'edit':
                return translator(messages.editVehicle); 
            case 'replace':
                return translator(messages.replaceVehicle);
            default:
                return '';
        }
    };

    const getNextStepText = () => {
        if (pageAction === 'add' || pageAction === 'replace') {
            return translator(messages.reviewCoverages);
        }
        return (
            <FormattedMessage
                {...messages.nextBaseDescription}
                values = {{
                    bold: (
                        <strong>{translator(messages.nextDescriptionBold)}</strong>
                    )
                }}
            />
        );
    };

    const checkForDuplicateVin = (vinInput) => {
        const validVehicles = vehiclesVM.value.filter((vehicle) => vehicle.isSelected !== true);   
        const vehicleVins = validVehicles.map((vehicle) => vehicle.vin);
        return vehicleVins.find((vin) => vin === vinInput) !== undefined;
    };

    const getUnderlyingPolicies = () => {
        let addedPolicy;
        if (underlyingPoliciesVM.value.findIndex((ulPolicy) => ulPolicy.ulPolicyFixID === 'new') === -1) {
            addedPolicy = pupModel.value.createUnderlyingPolicy({
                ulPolicyFixID: 'new',
                policyNumber: translator(messages.underlyingPolicyNotListed)
            });
        }

        const mappedValues = underlyingPoliciesVM.value.map((policy) => {
            let underlyingPolicyDisplayName = policy.getDisplayName(viewModelService.productMetadata, translator);
            if(isUMB_NP && policy.policyType === 'HO') {
                underlyingPolicyDisplayName = underlyingPolicyDisplayName.replace('Homeowners', 'Property');
            }
            return {
                code: policy.ulPolicyFixID,
                name: translator({
                    id: policy.policyNumber,
                    defaultMessage: underlyingPolicyDisplayName
                })
            };
        });

        if (addedPolicy !== undefined) {
            pupModel.value.removeUnderlyingPolicy(addedPolicy);
        }
        return mappedValues;
    };

    const hasNoChosenTerms = (terms) => {
        let flag = false;
        if (terms && terms.some((term) => _.isEmpty(term.chosenTerm))) {
            flag = true;
        }
        return flag;
    }

    const validateUnderlyingPolicy = (ulPolicyVM) => {
        let valid = true;
        const coverages = _.get(ulPolicyVM, 'value.ulPolicyCoverage.coverages');
        if (coverages && coverages.some((cov) => hasNoChosenTerms(cov.terms))) {
            valid = false;
        }
        return valid;
    };

    const checkforNonOwnedPolicy = (ulPolicyFixID) => {
        if (ulPolicyFixID === undefined) {
            return false;
        }
        const policy = pupModel.underlyingPolicies.value.find((ulPolicy) => ulPolicy.ulPolicyFixID === ulPolicyFixID);
        return policy && policy.namedNonOwner_Ext === true;
    }

    const addUnderlyingPolicy = (ulPolicyVM, checkUlPolicy) => {
        if (!(ulPolicyVM.aspects.valid && ulPolicyVM.aspects.subtreeValid)) {
            setShowValidationErrors(true);
            setErrorTimestamp(errorTimestamp+1);
            return;
        }
        if (!validateUnderlyingPolicy(ulPolicyVM)) return;

        currentVehicleVM.ulPolicyFixID.value = ulPolicyVM.ulPolicyFixID.value;
        checkUlPolicy();
        refreshData();
        return true;
    };

    const cancelAddUnderlyingPolicy = (policy) => {
        pupModel.value.removeUnderlyingPolicy(policy);
        currentVehicleVM.ulPolicyFixID.value = undefined;
        refreshData();
    };

    const getAddPolicyPopupProps = (underlyingVM, isEdit = false) => {
        const componentProps = {
            title: messages.addPolicy,
            viewModel: underlyingVM,
            uiProps: addUnderlyingPolicyPopupMetadata.pageContent,
            actionBtnLabel: messages.addPolicy,
            cancelBtnLabel: messages.cancel,
            getOverrideProps: () => {
                return {
                    underlyingPolicyComponent: {
                        underlyingPolicyVM: underlyingVM,
                        quoteID: submissionVM.value.jobID,
                        isPolicyChange: true,
                        onValidate,
                        showValidationErrors,
                        isEdit,
                        authHeader,
                        isComponent: true,
                        MLAlertService,
                        isModernProduct
                    }
                };
            },
            customComponentResolvers: {
                underlyingPolicyComponent: UnderlyingPolicyComponent
            },
        };

        return componentProps;
    };

    const onAddPolicy = (checkUlPolicy) => {
        const newUnderlyingPolicy = pupModel.value.createUnderlyingPolicy();
        const underlyingVM = underlyingPoliciesVM.findFirstElement(newUnderlyingPolicy);
        let componentProps = getAddPolicyPopupProps(underlyingVM);
        componentProps = {
            ...componentProps,
            onSaveAction: (ulPolicyVM) => addUnderlyingPolicy(ulPolicyVM, checkUlPolicy)
        };
        return modalApi.showModal(
            <FormModalPopover {...componentProps} />
        ).catch(() => cancelAddUnderlyingPolicy(underlyingVM.value));
    };

    const removeVinIfNotNeeded = (vehicle) => {
        const typesWithVin = ['private_passenger_autos_ml', 'vans_suvs_ml', 'pickups_ml', 'Motorcycle', 'collectible_ml', 'other'];
        if (!typesWithVin.includes(vehicle.value.type)) {
            vehicle.vin = undefined;
        }
    };

    const removePolicyIsNotListedSelectOption = () => {
        const index = underlyingPoliciesVM.value.findIndex((ulPolicy) => ulPolicy.ulPolicyFixID === 'new');
        const ulPolicy = underlyingPoliciesVM.getElement(index);
        if (ulPolicy && ulPolicy.value) {
            pupModel.value.removeUnderlyingPolicy(ulPolicy.value);
        }
    };

    const addNewVehicleAlert = (item) => {
        const param = item.value.getDisplayName();

        const alert = {
            alertName: alertNames.addedVehicleName,
            formattedMessageName: 'xHasBeenAdded',
            messagePram: MLCapitalizeStringFilter.capitalize(param)
        };
        const alertExists = alertMessages.some((msg) => {
            if (_.isEqual(msg, alert)) {
                return true;
            }
            return false;
        });

        if (!alertExists) {
            alertMessages.push(alert);
        }
    };

    const jumpToSelectedStepByStepID = useCallback((newStepID) => {
        MLEndorsementFlowUtil.addAndNavigateToSelectedStep(newStepID, steps, currentStepIndex, changeNextSteps, goNext, productCode); 
    },[changeNextSteps, currentStepIndex, goNext, productCode, steps]);

    const checkForVinOrSerialNumber = () => {        
        const serialNum = _.get(currentVehicleVM ,'serialNumber.value');
        const vin = _.get(currentVehicleVM ,'vin.value');

        if (! (vin > '' || serialNum > '')) {
            addErrorAlert(messages.vinOrSerialNumberRequired, 'VinOrSerial')
            return false;
        }

        return true;
    };

    const updateWizardSubmissionData = useCallback((vm) => {
        _.set(wizardData, 'submissionVM', vm);
        updateWizardData(wizardData);
    }, [updateWizardData, wizardData]);

    const onNext = () => {
        clearBlockAlerts('VinOrSerial')
        
        if (!(submissionVM.aspects.valid && submissionVM.aspects.subtreeValid)) {
            setShowValidationErrors(true);
            setErrorTimestamp(errorTimestamp+1);
            return;
        }

        if (currentVehicleVM.value.hasDuplicateVins) {
            return false;
        }

        const type = _.get(currentVehicleVM ,'type.value.code')
        if (type === 'Other' && !checkForVinOrSerialNumber()) {            
            return false;
        }

        removeVinIfNotNeeded(currentVehicleVM);
        removePolicyIsNotListedSelectOption();

        if (!currentVehicleVM.vin) {
            currentVehicleVM.vin = null;
        }

        if (currentVehicleVM.value.error.ulMessage) {
            window.scrollTo(0, 0);
            return false;
        }
        const lbl = MLEndorsementUtil.stepLabel(currentStep);
        MLEndorsementUtil.setEndorsementDescription(lbl, submissionVM, translator);

        currentVehicleVM.value.isSelected = false;

        const item = currentVehicleVM.value;
        const details = {
            data: `${item.year} ${item.make} ${item.model}`,
            fixedId: item.vin,
            replacedFixedId,
            pageAction: MLPolicyChangeDataHolderService.getPageAction()
        };
        MLNavigationStepsTrackingService.completeCurrentStep(details, authHeader,currentStep);
        if (!item.isEditing && pageAction !== 'edit') {
            addNewVehicleAlert(currentVehicleVM);
        }

        const promise = EndorsementService.saveEndorsement(
            [submissionVM.value],
            authHeader
        );

        showProgressDialog(messages.saving, promise);
        promise.then((updatedPolicyChange) => {
            const policyChange = new PolicyChange({ ...updatedPolicyChange });
            const updatedEndorsementVM = viewModelService.create(policyChange, 'pc', 'edge.capabilities.policychange.dto.PolicyChangeDataDTO');

            updateWizardSubmissionData(updatedEndorsementVM);
            MLTagManagerService.sendFormStepPolicyChangeStep(`${pageAction} Vehicle`);
            jumpToSelectedStepByStepID("endorsementAdditionalChanges");
        })

        
    };

    const getStatesList = () => {
        const states = currentVehicleVM?.licenseState?.aspects?.availableValues || [];

        return states
            .filter((state) => state.code !== 'ALL')
            .map((state) => ({
                ...state,
                name: translator({
                    id: state.name,
                    defaultMessage: state.name
                })
            }));
    };

    const resolvers = {
        resolveComponentMap: {
            mlpupeditvehiclecomponent: isloaded ? MLPUPEditVehicleComponent : undefined,
            MLStickyContinueSectionComponent,
            MLAlertGroupComponent
        },
        resolveCallbackMap: {
            onNext
        },
        resolveClassNameMap: {
            styles
        }
    }
    const overrideProps={
        contentContainer: {
            className: isGPA ? 'page-content-gpa' : ''
        },
        vehiclePolicyChangePageHeader:{
            content: getPageHeader()
        },
        pupEditVehicleComponent: {
            visible: isloaded,
            viewModelService: viewModelService,
            vehicleVM: currentVehicleVM,
            quoteID: submissionVM.jobID.value,
            endorsementState: _.get(submissionVM, 'baseData.policyAddress.state.value.code'),
            getUnderlyingPolicies,
            getStatesList,
            checkForDuplicateVin,
            checkforNonOwnedPolicy,
            onAddPolicy,
            isGPA,
            isUMB_NP,
            showValidationErrors,
            showProgressDialog,
            hideProgressDialog
        },
        nextDescription: {
            content: getNextStepText()
        },
        stickyContinueSection:{
            visible: isGPA,
            defaultContinueSectionId: 'footer',
            nextDescription: getNextStepText(),
            onNext
        }
    }

    return ( 
        <WizardPage
            showCancel={false}
            showPrevious={false}
            showNext={false}
            policyChangePageHeaderML={isAMP ? null : messages.makeChanges}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                overrideProps={overrideProps}
                model={submissionVM}
                onModelChange={updateWizardData}
                componentMap={resolvers.resolveComponentMap}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                onValidationChange={onValidate}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    )
}

PUPVehiclesPagePolChange.propTypes= wizardProps;
export default PUPVehiclesPagePolChange;